import { TRADINGHISTORY__MUTATIONS } from "../mutation-types";
import { TRADINGHISTORY__ACTIONS } from "../action-types";
import { TRADINGHISTORY__API } from "@/_helpers/urls";
import http from "@/_helpers/http";

// State
const state = {
  live_trades_history: {
    trades: [],
    totalProfit: 0,
  },

  closed_trades_history: {
    trades: [],
    totalProfit: 0,
  },
};

const getters = {};

// Mutations
const mutations = {
  [TRADINGHISTORY__MUTATIONS.CLIENTLIVETRADESREPORTS](state, data) {
    state.live_trades_history.trades = data?.data;
    state.live_trades_history.totalProfit = data?.totalProfit;
  },

  [TRADINGHISTORY__MUTATIONS.CLIENTCLOSEDTRADESREPORTS](state, data) {
    state.closed_trades_history.trades = data?.data;
    state.closed_trades_history.totalProfit = data?.totalProfit;
  },
};

// Actions
const actions = {
  async [TRADINGHISTORY__ACTIONS.CLIENTLIVETRADESREPORTS](
    { commit },
    parameter
  ) {
    try {
      commit("SET_LOADING", true);

      const accountTypeParam =
        parameter?.account_type != null
          ? `account_type=${parameter.account_type}`
          : "";

      const durationParam =
        parameter?.date != null ? `date=${parameter.date}` : "";

      const parameterString = [accountTypeParam, durationParam]
        .filter((param) => param !== "")
        .join("&");

      const { data } = await http().get(
        TRADINGHISTORY__API.CLIENTLIVETRADESREPORTS +
          (parameterString !== "" ? `?${parameterString}` : "")
      );

      commit(TRADINGHISTORY__MUTATIONS.CLIENTLIVETRADESREPORTS, data);
    } catch (error) {
      console.error("Error live trades history:", error);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async [TRADINGHISTORY__ACTIONS.CLIENTCLOSEDTRADESREPORTS](
    { commit },
    parameter
  ) {
    try {
      commit("SET_LOADING", true);

      const accountTypeParam =
        parameter?.account_type != null
          ? `account_type=${parameter.account_type}`
          : "";

      const durationParam =
        parameter?.date != null ? `date=${parameter.date}` : "";

      const parameterString = [accountTypeParam, durationParam]
        .filter((param) => param !== "")
        .join("&");

      const { data } = await http().get(
        TRADINGHISTORY__API.CLIENTCLOSEDTRADESREPORTS +
          (parameterString !== "" ? `?${parameterString}` : "")
      );

      commit(TRADINGHISTORY__MUTATIONS.CLIENTCLOSEDTRADESREPORTS, data);
    } catch (error) {
      console.error("Error closed trades history:", error);
    } finally {
      commit("SET_LOADING", false);
    }
  },
};

export default {
  strict: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
